import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { giantAnimations } from '../../admin-layout/animations';
import { GiantConfigService } from '../../admin-layout/services/config-service';
import { Router } from '@angular/router';
import { LoginRepository } from 'src/app/repositories/login/LoginRepository';
import { Login } from 'src/app/models/login.model';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { navigation } from 'src/app/shared/navigation';
import { GiantSnackBarService } from 'src/app/shared/utils/giant-snack-bar';



@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: giantAnimations
})
export class LoginComponent implements OnInit {
    loginForm: UntypedFormGroup;
    loginModel = new Login();
    navObj: any[] = [{ id: 'pages', title: 'Pages', type: 'group', icon: 'pages', children: [] }];
    constructor(
        private _giantConfigService: GiantConfigService,
        private _formBuilder: UntypedFormBuilder,
        private _loginRepository: LoginRepository,
        private _router: Router,
        private _userRepository: UserRepository,
        private _giantSnackBarService: GiantSnackBarService

    ) {
        // Configure the layout
        this._giantConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loginForm = this._formBuilder.group({
            username: ['', [Validators.required]],
            password: ['', Validators.required]
        });
    }
    onLogin(form: any) {
        debugger
        this.loginModel.Username = form.value.username;
        this.loginModel.Password = form.value.password;


        this._loginRepository.Authentication(this.loginModel).subscribe((response: any) => {
            if (response.access_token != null) {
                localStorage.setItem('userToken', response.access_token);
                this._router.navigate(['/tf-authentication'])
            }
            
        },(error:any) =>{
            console.log('error is =' + error);
            this._giantSnackBarService.snackbarError('Invalid username and password')
        });
    }

    ForgetPassword() {
        this._router.navigate(['/forgetpassword'])
    }
}
